<template>
  <v-container>
    <v-row v-if="biometricos.length > 0">
      <v-col
        v-for="biometrico in biometricos"
        :key="biometrico.id"
        cols="3"
      >
        <v-card
          color="secondary"
          tile
        >
          <v-card-title class="d-inline-block">
            <div class="text-subtitle-1 font-weight-bold white--text">
              {{ biometrico.CatTipoBiometrico.title }}
            </div>
            <div class="text-subtitle-2 primary--text">
              Archivo cargado el {{ biometrico.fechaAdjuntados }}
            </div>
          </v-card-title>
          <v-card-text>
            <div class="text-caption primary--text">
              Observaciones
            </div>
            <div
              v-if="biometrico.observaciones !== ''"
              class="text-body-2 primary--text font-weight-bold"
            >
              {{ biometrico.observaciones }}
            </div>
            <div
              v-else
              class="text-body-2 primary--text font-weight-bold"
            >
              No hay observaciones
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              icon
              color="white"
              class="mr-4"
              @click="download(biometrico.URL)"
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        align="center"
      >
        <div class="text-subtitle-1 font-weight-bold text--disabled">
          No hay biométricos registrados.
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('biometrico', {
      biometricos: 'getBiometricosExpediente',
    }),
  },
};
</script>
